module.exports = "/build/images/logo-q.svg?2a4e52bf35d10596480a14e3cc29d111";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/logo-q.svg
// module id = 4526
// module chunks = 0